import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-discounts',
  templateUrl: './home-discounts.component.html',
  styleUrls: ['./home-discounts.component.scss']
})
export class HomeDiscountsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
